import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "dls-fonts/dist/styles/geomanist.min.css";
import App from "./app";
import reportWebVitals from "./reportWebVitals";
import "fontsource-roboto";
import theme from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import moment from "moment";
import "moment/locale/pt-br";
import "apw-componentes";
import "apw-componentes/build/style/dls-componentes.css";

moment.locale(["pt-br", "pr-br"]);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
